import H1 from "./H1/H1.jsx";
import H2 from "./H2/H2.jsx";
import H3 from "./H3/H3.jsx";
import P from "./P/P.jsx";

export { H1, H2, H3, P };
